import { Component, OnInit } from '@angular/core';
import { RolesService } from '../../../core/services/roles.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionAlert } from '../../../core/dto/actionAlert';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-add-edit-roles',
  templateUrl: './add-edit-roles.component.html',
  styleUrls: ['./add-edit-roles.component.scss'],
})
export class AddEditRolesComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Users',
      icon: 'user',
      route: '/admin/users',
    },
    {
      title: 'Add New Role',
    },
  ];

  // Role fields
  name = '';
  permissions: any[] = [];

  permissionOptions: any[] = [];
  lastPermissionOptionsState: any[] = [];
  nameInvalid = false;

  fleetPermissions: any[] = [];
  userPermissions: any[] = [];
  rolePermissions: any[] = [];
  driverPermissions: any[] = [];
  supplierPermissions: any[] = [];
  supplierOtherPermissions: any[] = [];
  supplierDriverPermissions: any[] = [];
  supplierVehiclePermissions: any[] = [];
  supplierNotePermissions: any[] = [];
  inventoryRecordsPermissions: any[] = [];
  serviceRecordsPermissions: any[] = [];
  repairRecordsPermissions: any[] = [];
  accidentRecordsPermissions: any[] = [];
  notesAndAttachmentsPermissions: any[] = [];
  customerPermissions: any[] = [];
  // customerAttachmentsPermissions: any[] = [];
  customerBookingPermissions: any[] = [];
  customerNotesAttachmentsPermissions: any[] = [];
  // customerNotesPermissions: any[] = [];
  rentBookingPermissions: any[] = [];
  rentBookingCostPermissions: any[] = [];
  rentBookingRemarksPermissions: any[] = [];
  rentBookingUserCommentsPermissions: any[] = [];
  otherBookingPermissions: any[] = [];
  transferBookingPermissions: any[] = [];
  agentPermissions: any[] = [];
  agentBookingPermissions: any[] = [];
  currencyPermissions: any[] = [];
  reportPermissions: any[] = [];

  fleetPermValues: any[] = [];
  userPermValues: any[] = [];
  rolePermValues: any[] = [];
  driverPermValues: any[] = [];
  supplierPermValues: any[] = [];
  supplierOtherPermValues: any[] = [];
  supplierDriverPermValues: any[] = [];
  supplierVehiclePermValues: any[] = [];
  supplierNotePermValues: any[] = [];
  inventoryRecordsPermValues: any[] = [];
  serviceRecordsPermValues: any[] = [];
  repairRecordsPermValues: any[] = [];
  accidentRecordsPermValues: any[] = [];
  notesAndAttachmentsPermValues: any[] = [];
  customerPermValues: any[] = [];
  // customerAttachmentsPermValues: any[] = [];
  customerBookingPermValues: any[] = [];
  customerNotesAttachmentsPermValues: any[] = [];
  // customerNotesPermValues: any[] = [];
  rentBookingPermValues: any[] = [];
  rentBookingCostPermValues: any[] = [];
  rentBookingRemarksPermValues: any[] = [];
  rentBookingUserCommentPermValues: any[] = [];
  transferBookingPermValues: any[] = [];
  otherBookingPermValues: any[] = [];
  agentPermValues: any[] = [];
  agentBookingPermValues: any[] = [];
  currencyPermValues: any[] = [];
  reportPermValues: any[] = [];

  id: any;
  editableRole: any;

  lastOptionGroup: any;
  loading = false;
  actionMessage = new ActionAlert();

  constructor(
    private rolesService: RolesService,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.getPermissionOptions();
  }

  wordCapitalize(word: string): string {
    const lower = word.toLowerCase();
    return word.charAt(0).toUpperCase() + lower.slice(1);
  }

  getPermissionOptions(): any {
    this.loading = true;
    this.rolesService.getPermissionsByGroup().then((res: any) => {
      res.forEach((permisson: any) => {
        const nameParts = permisson.name.split(' ');
        const firstName = nameParts[0];
        nameParts.shift();
        const labelName = nameParts.join(' ');
        switch (firstName) {
          case 'Fleet':
            this.fleetPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Agent':
            this.agentPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Agent_Booking':
            this.agentBookingPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Currency':
            this.currencyPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Report':
            this.reportPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Inventory_Records':
            this.inventoryRecordsPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Service_Records':
            this.serviceRecordsPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Repair_Records':
            this.repairRecordsPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Accident_Records':
            this.accidentRecordsPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Notes_Attachments':
            this.notesAndAttachmentsPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'User':
            this.userPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Role':
            this.rolePermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Driver':
            this.driverPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Supplier':
            const supplierLabelNameParts = labelName.split(' ');
            if (supplierLabelNameParts[0] === 'Driver') {
              supplierLabelNameParts.shift();
              const driverLabel = supplierLabelNameParts.join(' ');
              this.supplierDriverPermissions.push({
                label: driverLabel,
                value: permisson._id,
              });
            } else if (supplierLabelNameParts[0] === 'Vehicle') {
              supplierLabelNameParts.shift();
              const vehicleLabel = supplierLabelNameParts.join(' ');
              this.supplierVehiclePermissions.push({
                label: vehicleLabel,
                value: permisson._id,
              });
            } else if (supplierLabelNameParts[0] === 'Notes') {
              supplierLabelNameParts.shift();
              const vehicleLabel = supplierLabelNameParts.join(' ');
              this.supplierNotePermissions.push({
                label: vehicleLabel,
                value: permisson._id,
              });
            } else {
              this.supplierPermissions.push({
                label: labelName,
                value: permisson._id,
              });
            }
            break;
          case 'Customer':
            const customerLabelNameParts = labelName.split(' ');
            if (customerLabelNameParts[0] === 'Note_Attachment') {
              customerLabelNameParts.shift();
              const attachLabel = customerLabelNameParts.join(' ');
              this.customerNotesAttachmentsPermissions.push({
                label: attachLabel,
                value: permisson._id,
              });
            }
            // if (customerLabelNameParts[0] === 'Attachments') {
            //   customerLabelNameParts.shift();
            //   const attachLabel = customerLabelNameParts.join(' ');
            //   this.customerAttachmentsPermissions.push({
            //     label: attachLabel,
            //     value: permisson._id,
            //   });
            // }
            else if (customerLabelNameParts[0] === 'Booking') {
              customerLabelNameParts.shift();
              const bookingLabel = customerLabelNameParts.join(' ');
              this.customerBookingPermissions.push({
                label: bookingLabel,
                value: permisson._id,
              });
            }
            // else if (customerLabelNameParts[0] === 'Notes') {
            //   customerLabelNameParts.shift();
            //   const notesLabel = customerLabelNameParts.join(' ');
            //   this.customerNotesPermissions.push({
            //     label: notesLabel,
            //     value: permisson._id,
            //   });
            // }
            else {
              this.customerPermissions.push({
                label: labelName,
                value: permisson._id,
              });
            }
            break;
          case 'Rent_Booking':
            const rentBookingLabelNameParts = labelName.split(' ');
            if (rentBookingLabelNameParts[0] === 'Cost') {
              rentBookingLabelNameParts.splice(0, 2);
              const costLabel = rentBookingLabelNameParts.join(' ');
              this.rentBookingCostPermissions.push({
                label: costLabel,
                value: permisson._id,
              });
            } else if (rentBookingLabelNameParts[0] === 'User') {
              rentBookingLabelNameParts.splice(0, 2);
              const commentLabel = rentBookingLabelNameParts.join(' ');
              this.rentBookingUserCommentsPermissions.push({
                label: commentLabel,
                value: permisson._id,
              });
            } else if (rentBookingLabelNameParts[0] === 'Remarks') {
              rentBookingLabelNameParts.shift();
              const remarksLabel = rentBookingLabelNameParts.join(' ');
              this.rentBookingRemarksPermissions.push({
                label: remarksLabel,
                value: permisson._id,
              });
            } else {
              this.rentBookingPermissions.push({
                label: labelName,
                value: permisson._id,
              });
            }
            break;
          case 'Transfer_Booking':
            this.transferBookingPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
          case 'Other_Booking':
            this.otherBookingPermissions.push({
              label: labelName,
              value: permisson._id,
            });
            break;
        }
      });
      this.checkIsUpdate();
    });
  }

  checkIsUpdate() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.id = this.route.snapshot.paramMap.get('id');
      this.breadcrumbs[1] = {
        title: 'Update Role',
      };
      this.rolesService.getOneRoleById(this.id).then((res: any) => {
        this.editableRole = res;
        this.setEditableRolePermissions(this.editableRole.permissions);
        this.permissions = this.editableRole.permissions;
        this.name = this.wordCapitalize(this.editableRole.name);
        this.setViewDisable();
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  setEditableRolePermissions(permissions: any): void {
    permissions.forEach((permVal: any) => {
      this.userPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.userPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Reset Password' ||
            perm.label === 'Change Status') &&
          perm.checked
        ) {
          const viewPermIndex = this.userPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.userPermissions[viewPermIndex].checked = true;
            this.userPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.rolePermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.rolePermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete') &&
          perm.checked
        ) {
          const viewPermIndex = this.rolePermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.rolePermissions[viewPermIndex].checked = true;
            this.rolePermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.agentPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.agentPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' || perm.label === 'Create') &&
          perm.checked
        ) {
          const viewPermIndex = this.agentPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.agentPermissions[viewPermIndex].checked = true;
            this.agentPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.agentBookingPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.agentBookingPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' || perm.label === 'Create') &&
          perm.checked
        ) {
          const viewPermIndex = this.agentBookingPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.agentBookingPermissions[viewPermIndex].checked = true;
            this.agentBookingPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.currencyPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.currencyPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Change Status') &&
          perm.checked
        ) {
          const viewPermIndex = this.currencyPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.currencyPermissions[viewPermIndex].checked = true;
            this.currencyPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.fleetPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.fleetPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View' ||
            perm.label === 'Availability' ||
            perm.label === 'Wash Status') &&
          perm.checked
        ) {
          const viewPermIndex = this.fleetPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.fleetPermissions[viewPermIndex].checked = true;
            this.fleetPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.reportPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.reportPermValues.push(perm.value);
        }
      });

      this.inventoryRecordsPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.inventoryRecordsPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.inventoryRecordsPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.inventoryRecordsPermissions[viewPermIndex].checked = true;
            this.inventoryRecordsPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.serviceRecordsPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.serviceRecordsPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.serviceRecordsPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.serviceRecordsPermissions[viewPermIndex].checked = true;
            this.serviceRecordsPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.repairRecordsPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.repairRecordsPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.repairRecordsPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.repairRecordsPermissions[viewPermIndex].checked = true;
            this.repairRecordsPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.accidentRecordsPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.accidentRecordsPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.accidentRecordsPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.accidentRecordsPermissions[viewPermIndex].checked = true;
            this.accidentRecordsPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.notesAndAttachmentsPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.notesAndAttachmentsPermValues.push(perm.value);
        }
      });

      this.driverPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.driverPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.driverPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.driverPermissions[viewPermIndex].checked = true;
            this.driverPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.supplierPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.supplierPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.supplierPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.supplierPermissions[viewPermIndex].checked = true;
            this.supplierPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.supplierDriverPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.supplierDriverPermValues.push(perm.value);
        }
      });

      this.supplierVehiclePermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.supplierVehiclePermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete') &&
          perm.checked
        ) {
          const viewPermIndex = this.supplierVehiclePermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.supplierVehiclePermissions[viewPermIndex].checked = true;
            this.supplierVehiclePermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.supplierNotePermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.supplierNotePermValues.push(perm.value);
        }
      });

      this.customerPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.customerPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.customerPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.customerPermissions[viewPermIndex].checked = true;
            this.customerPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      // this.customerAttachmentsPermissions.forEach((perm: any) => {
      //   if (perm.value === permVal.toString()) {
      //     perm.checked = true;
      //     this.customerAttachmentsPermValues.push(perm.value);
      //   }
      // });
      //
      // this.customerNotesPermissions.forEach((perm: any) => {
      //   if (perm.value === permVal.toString()) {
      //     perm.checked = true;
      //     this.customerNotesPermValues.push(perm.value);
      //   }
      // });

      this.customerNotesAttachmentsPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.customerNotesAttachmentsPermValues.push(perm.value);
        }
      });

      this.customerBookingPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.customerBookingPermValues.push(perm.value);
        }
      });

      this.rentBookingPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.rentBookingPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Change Status' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.rentBookingPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.rentBookingPermissions[viewPermIndex].checked = true;
            this.rentBookingPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.rentBookingCostPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.rentBookingCostPermValues.push(perm.value);
        }
      });

      this.rentBookingUserCommentsPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.rentBookingUserCommentPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Delete') &&
          perm.checked
        ) {
          const viewPermIndex =
            this.rentBookingUserCommentsPermissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
          if (viewPermIndex !== -1) {
            this.rentBookingUserCommentsPermissions[viewPermIndex].checked =
              true;
            this.rentBookingUserCommentsPermissions[viewPermIndex].disabled =
              true;
          }
        }
      });

      this.rentBookingRemarksPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.rentBookingRemarksPermValues.push(perm.value);
        }
      });

      this.transferBookingPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.transferBookingPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Change Status' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.transferBookingPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.transferBookingPermissions[viewPermIndex].checked = true;
            this.transferBookingPermissions[viewPermIndex].disabled = true;
          }
        }
      });

      this.otherBookingPermissions.forEach((perm: any) => {
        if (perm.value === permVal.toString()) {
          perm.checked = true;
          this.otherBookingPermValues.push(perm.value);
        }
        if (
          (perm.label === 'Update' ||
            perm.label === 'Create' ||
            perm.label === 'Change Status' ||
            perm.label === 'Delete' ||
            perm.label === 'Single View') &&
          perm.checked
        ) {
          const viewPermIndex = this.otherBookingPermissions.findIndex(
            (p: { label: string }) => p.label === 'View',
          );
          if (viewPermIndex !== -1) {
            this.otherBookingPermissions[viewPermIndex].checked = true;
            this.transferBookingPermissions[viewPermIndex].disabled = true;
          }
        }
      });
    });
  }

  getOneRoleById(id: any): void {
    this.rolesService.getOneRoleById(id).then((res: any) => {
      this.editableRole = res;
    });
  }

  setViewDisable(): void {}

  log(permissions: any[], type: string, event: any): void {
    switch (type) {
      case 'user':
        this.userPermValues = [];

        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Reset Password' ||
              perm.label === 'Change Status') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            // console.log(perm)
            this.userPermValues.push(perm.value);
          }
        });
        break;
      case 'role':
        this.rolePermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.rolePermValues.push(perm.value);
          }
        });
        break;
      case 'agent':
        this.agentPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' || perm.label === 'Create') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.agentPermValues.push(perm.value);
          }
        });
        break;
      case 'agent_bookings':
        this.agentBookingPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' || perm.label === 'Create') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.agentBookingPermValues.push(perm.value);
          }
        });
        break;
      case 'currency':
        this.currencyPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Change Status') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.currencyPermValues.push(perm.value);
          }
        });
        break;
      case 'report':
        this.reportPermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.reportPermValues.push(perm.value);
          }
        });
        break;
      case 'fleet':
        this.fleetPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.fleetPermValues.push(perm.value);
          }
        });
        break;
      case 'service':
        this.serviceRecordsPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.serviceRecordsPermValues.push(perm.value);
          }
        });
        break;
      case 'inventory':
        this.inventoryRecordsPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.inventoryRecordsPermValues.push(perm.value);
          }
        });
        break;
      case 'repair':
        this.repairRecordsPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.repairRecordsPermValues.push(perm.value);
          }
        });
        break;
      case 'accident':
        this.accidentRecordsPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.accidentRecordsPermValues.push(perm.value);
          }
        });
        break;
      case 'notes':
        this.notesAndAttachmentsPermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.notesAndAttachmentsPermValues.push(perm.value);
          }
        });
        break;
      case 'driver':
        this.driverPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.driverPermValues.push(perm.value);
          }
        });
        break;
      case 'supplier':
        this.supplierPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.supplierPermValues.push(perm.value);
          }
        });
        break;
      case 'supplier-vehicle':
        this.supplierVehiclePermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.supplierVehiclePermValues.push(perm.value);
          }
        });
        break;
      case 'supplier-driver':
        this.supplierDriverPermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.supplierDriverPermValues.push(perm.value);
          }
        });
        break;
      case 'supplier-note':
        this.supplierNotePermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.supplierNotePermValues.push(perm.value);
          }
        });
        break;
      case 'customer':
        this.customerPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.customerPermValues.push(perm.value);
          }
        });
        break;
      // case 'customer-attachments':
      //   this.customerAttachmentsPermValues = [];
      //   permissions.forEach((perm: any) => {
      //     if (perm.checked) {
      //       this.customerAttachmentsPermValues.push(perm.value);
      //     }
      //   });
      //   break;
      case 'customer-note-attachment':
        this.customerNotesAttachmentsPermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.customerNotesAttachmentsPermValues.push(perm.value);
          }
        });
        break;
      case 'customer-booking':
        this.customerBookingPermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.customerBookingPermValues.push(perm.value);
          }
        });
        break;
      // case 'customer-notes':
      //   this.customerNotesPermValues = [];
      //   permissions.forEach((perm: any) => {
      //     if (perm.checked) {
      //       this.customerNotesPermValues.push(perm.value);
      //     }
      //   });
      //   break;
      case 'rent_booking':
        this.rentBookingPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Change Status' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.rentBookingPermValues.push(perm.value);
          }
        });
        break;
      case 'rent_booking-cost':
        this.rentBookingCostPermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.rentBookingCostPermValues.push(perm.value);
          }
        });
        break;
      case 'rent_booking-comments':
        this.rentBookingUserCommentPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.rentBookingUserCommentPermValues.push(perm.value);
          }
        });
        break;
      case 'rent_booking-remarks':
        this.rentBookingRemarksPermValues = [];
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.rentBookingRemarksPermValues.push(perm.value);
          }
        });
        break;
      case 'transfer_booking':
        this.transferBookingPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Change Status' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.transferBookingPermValues.push(perm.value);
          }
        });
        break;
      case 'other_booking':
        this.otherBookingPermValues = [];
        for (const perm of permissions) {
          if (
            (perm.label === 'Update' ||
              perm.label === 'Create' ||
              perm.label === 'Change Status' ||
              perm.label === 'Delete' ||
              perm.label === 'Single View') &&
            perm.checked
          ) {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].checked = true;
              permissions[viewPermIndex].disabled = true;
            }
            break;
          } else {
            const viewPermIndex = permissions.findIndex(
              (p: { label: string }) => p.label === 'View',
            );
            if (viewPermIndex !== -1) {
              permissions[viewPermIndex].disabled = false;
            }
          }
        }
        permissions.forEach((perm: any) => {
          if (perm.checked) {
            this.otherBookingPermValues.push(perm.value);
          }
        });
        break;
    }
    this.permissions = this.userPermValues.concat(
      this.rolePermValues,
      this.fleetPermValues,
      this.driverPermValues,
      this.supplierPermValues,
      this.inventoryRecordsPermValues,
      this.serviceRecordsPermValues,
      this.repairRecordsPermValues,
      this.accidentRecordsPermValues,
      this.notesAndAttachmentsPermValues,
      this.customerPermValues,
      this.rentBookingPermValues,
      this.rentBookingCostPermValues,
      this.rentBookingUserCommentPermValues,
      this.rentBookingRemarksPermValues,
      this.transferBookingPermValues,
      this.otherBookingPermValues,
      this.supplierDriverPermValues,
      this.supplierVehiclePermValues,
      this.supplierNotePermValues,
      // this.customerAttachmentsPermValues,
      // this.customerNotesPermValues,
      this.customerNotesAttachmentsPermValues,
      this.customerBookingPermValues,
      this.agentPermValues,
      this.agentBookingPermValues,
      this.currencyPermValues,
      this.reportPermValues,
    );
  }

  checkValid(): boolean {
    return (
      this.name === undefined ||
      this.name === null ||
      this.name === '' ||
      !this.permissions.length
    );
  }

  checkRoleNameValid(): void {
    this.nameInvalid =
      this.name === undefined || this.name === null || this.name === '';
  }

  async addEditRole(): Promise<void> {
    try {
      if (this.id) {
        await this.rolesService.updateRole({
          _id: this.id,
          name: this.name.toUpperCase(),
          permissions: this.permissions,
        });
        this.name = '';
        this.permissions = [];
        this.permissionOptions = [];
        this.message.success('Role has been updated!');
        this.getPermissionOptions();
        this.router.navigate(['/admin/users/roles']);
      } else {
        await this.rolesService.createRole({
          name: this.name.toUpperCase(),
          permissions: this.permissions,
        });
        this.name = '';
        this.permissions = [];
        this.permissionOptions = [];
        this.message.success('New role has been added!');
        this.getPermissionOptions();
        this.router.navigate(['/admin/users/roles']);
      }
    } catch (e: any) {
      if (e.type === 'exist') {
        this.actionMessage = new ActionAlert(true, e.message, 'error');
      }
    }
  }
}
